function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 108 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "var(--on-surface)",
    clipPath: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33.721 3.748A4.303 4.303 0 0 0 30.677.717C27.992 0 17.22 0 17.22 0S6.45 0 3.765.717A4.303 4.303 0 0 0 .72 3.747C0 6.42 0 12 0 12s0 5.58.72 8.252a4.303 4.303 0 0 0 3.045 3.031C6.45 24 17.221 24 17.221 24s10.77 0 13.456-.717a4.303 4.303 0 0 0 3.044-3.03c.72-2.674.72-8.253.72-8.253s-.002-5.58-.72-8.252ZM13.774 17.142 22.72 12l-8.947-5.142v10.284Z",
    clipRule: "evenodd",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.847 1.702 3.867 13.902h-.003v6.669h3.351v-6.669l3.916-13.902h-3.374L44.2 8.026c-.394 1.849-.649 3.164-.762 3.949h-.1a58.77 58.77 0 0 0-.762-3.971L41.22 1.702h-3.374Z",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M49.992 21.832c-.68-.457-1.165-1.168-1.454-2.133-.286-.966-.43-2.247-.43-3.85v-2.181c0-1.618.164-2.919.492-3.898.33-.98.843-1.696 1.54-2.145.697-.448 1.613-.674 2.747-.674 1.117 0 2.01.228 2.685.686.672.457 1.165 1.174 1.477 2.144.312.974.468 2.27.468 3.886v2.182c0 1.603-.153 2.89-.456 3.86-.304.975-.797 1.686-1.478 2.134-.68.45-1.604.675-2.77.675-1.202.003-2.14-.229-2.82-.686Zm3.817-2.354c.187-.49.283-1.29.283-2.401v-4.682c0-1.078-.093-1.868-.283-2.365-.19-.5-.522-.748-.998-.748-.46 0-.786.248-.973.748-.19.5-.283 1.287-.283 2.365v4.682c0 1.112.09 1.913.272 2.401.181.492.507.737.984.737.476 0 .808-.245.998-.736Z",
    clipRule: "evenodd",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.833 22.276h2.659V7.242h-3.397v11.94a1.691 1.691 0 0 1-.603.687c-.273.18-.556.27-.851.27-.346 0-.593-.143-.74-.428-.147-.286-.221-.762-.221-1.434V7.245h-3.4v11.23c0 1.388.239 2.41.715 3.064.476.652 1.216.98 2.217.98 1.446 0 2.529-.695 3.252-2.083h.074l.295 1.84Z",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.726 4.425h-3.374v17.85h-3.325V4.425h-3.374v-2.72h10.073v2.72Z",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.266 22.276h2.66V7.242h-3.397v11.94a1.691 1.691 0 0 1-.604.687c-.272.18-.556.27-.85.27-.347 0-.593-.143-.74-.428-.148-.286-.222-.762-.222-1.434V7.245h-3.4v11.23c0 1.388.24 2.41.715 3.064.477.652 1.217.98 2.218.98 1.445 0 2.528-.695 3.251-2.083h.074l.295 1.84Z",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M97.175 9.646c-.206-.948-.538-1.634-.998-2.06-.459-.426-1.091-.638-1.896-.638-.624 0-1.208.175-1.75.528a3.59 3.59 0 0 0-1.256 1.386h-.025V.942h-3.275v21.33h2.807l.346-1.422h.074c.263.508.657.906 1.182 1.203.525.293 1.109.44 1.75.44 1.148 0 1.995-.528 2.537-1.58.541-1.056.813-2.701.813-4.942v-2.38c0-1.679-.105-2.996-.309-3.945ZM94.06 15.78c0 1.095-.046 1.953-.136 2.574-.091.62-.242 1.064-.457 1.323-.213.263-.502.393-.862.393-.28 0-.538-.065-.777-.198a1.482 1.482 0 0 1-.578-.587v-8.531c.113-.41.312-.743.593-1.005.277-.263.584-.392.91-.392.346 0 .612.135.8.403.189.271.32.723.393 1.36.074.638.11 1.544.11 2.721v1.939h.004ZM102.392 18.816c-.057-.483-.085-1.206-.085-2.17v-.763H108V13.31c0-1.586-.128-2.827-.383-3.728-.255-.9-.694-1.56-1.318-1.987-.624-.426-1.52-.637-2.685-.637-1.693 0-2.886.519-3.584 1.557-.697 1.039-1.046 2.687-1.046 4.942v2.625c0 2.19.335 3.807 1.01 4.854.671 1.047 1.845 1.57 3.521 1.57 1.395 0 2.475-.345 3.238-1.031.762-.686 1.145-1.724 1.145-3.113 0-.229-.009-.41-.026-.539l-2.931-.172c-.017.914-.119 1.57-.309 1.961-.187.393-.539.59-1.046.59-.377 0-.655-.11-.837-.33-.181-.223-.3-.573-.357-1.055Zm0-8.213c.06-.483.173-.83.346-1.041.17-.212.437-.32.799-.322.361 0 .627.104.8.307.173.206.292.556.357 1.056s.099 1.23.099 2.196v1.078h-2.486v-1.078c0-.983.028-1.713.085-2.196Z",
    clipRule: "evenodd",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h108v24H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }))));
};
export default SvgYoutube;